import 'css-chunk:../touch/long-press-indicator/index.module.scss';export default {
  "indicator": "_indicator_1veto_1"
};